export const EXTENDED_TSHIRT_SIZING = {
  "2xl": "68px",
  "3xl": "100px",
};

export interface SpinnerSharedProps {
  size?:
    | "xs" // 12px
    | "sm" // 16px
    | "md" // 20px
    | "lg" // 32px
    | "xl" // 40px
    | keyof typeof EXTENDED_TSHIRT_SIZING
    // eslint-disable-next-line
    | (string & {});

  // Enter any props that are shared from web/native
  "data-testid"?: string;
  color?: string;
  emptyColor?: string;
  speed?: string;
  thickness?: string;
  m?: string;
}
